import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "customRadio", "classroomRadio", "customTeachersRadio", "typeRadio",
    "criteriaRadio", "parentSelection", "classroomSelection",
    "teacherSelection", "typeSelection", "parentsSelect", "teachersSelect"
  ]
  static values = { lookupUrl: String, teacherLookupUrl: String }

  connect() {
    this.parentsSelect2Initialized = false
    this.teachersSelect2Initialized = false
    this.toggle()
  }

  toggle() {
    if (this.hasParentSelectionTarget) {
      const showParents = this.hasCustomRadioTarget && this.customRadioTarget.checked
      this.parentSelectionTarget.classList.toggle("d-none", !showParents)
      if (showParents) this.initializeParentsSelect2()
      else this.clearSelect(this.parentsSelectTarget)
    }

    if (this.hasClassroomSelectionTarget && this.hasClassroomRadioTarget) {
      this.classroomSelectionTarget.classList.toggle("d-none", !this.classroomRadioTarget.checked)
    }

    if (this.hasTeacherSelectionTarget) {
      const showTeachers = this.hasCustomTeachersRadioTarget && this.customTeachersRadioTarget.checked
      this.teacherSelectionTarget.classList.toggle("d-none", !showTeachers)
      if (showTeachers) this.initializeTeachersSelect2()
      else this.clearSelect(this.teachersSelectTarget)
    }

    if (this.hasTypeSelectionTarget && this.hasTypeRadioTarget) {
      this.typeSelectionTarget.classList.toggle("d-none", !this.typeRadioTarget.checked)
    }
  }

  clearSelect(selectEl) {
    if (!selectEl) return
    if (typeof $ !== "undefined" && $.fn.select2 && $(selectEl).data("select2")) {
      $(selectEl).val(null).trigger("change")
    } else {
      Array.from(selectEl.options).forEach(opt => { opt.selected = false })
    }
  }

  initializeParentsSelect2() {
    if (this.parentsSelect2Initialized || !this.hasParentsSelectTarget) return
    if (typeof $ === "undefined" || !$.fn.select2) return

    this.loadInitialOptions(this.lookupUrlValue, this.parentsSelectTarget)
      .then(() => {
        $(this.parentsSelectTarget).select2({
          width: "100%",
          multiple: true,
          placeholder: "Search parents by name or email",
          minimumInputLength: 2,
          ajax: this.select2AjaxConfig(this.lookupUrlValue)
        })
        this.parentsSelect2Initialized = true
      })
  }

  initializeTeachersSelect2() {
    if (this.teachersSelect2Initialized || !this.hasTeachersSelectTarget) return
    if (typeof $ === "undefined" || !$.fn.select2) return

    this.loadInitialOptions(this.teacherLookupUrlValue, this.teachersSelectTarget)
      .then(() => {
        $(this.teachersSelectTarget).select2({
          width: "100%",
          multiple: true,
          placeholder: "Search teachers by name or email",
          minimumInputLength: 2,
          ajax: this.select2AjaxConfig(this.teacherLookupUrlValue)
        })
        this.teachersSelect2Initialized = true
      })
  }

  select2AjaxConfig(lookupUrl) {
    return {
      delay: 250,
      transport: (params, success, failure) => {
        Rails.ajax({
          url: `${lookupUrl}?${$.param(params.data)}`,
          type: "GET",
          dataType: "json",
          success,
          error: failure
        })
      },
      data: params => ({ q: params.term, page: params.page || 1 }),
      processResults: (data) => ({
        results: data.results || [],
        pagination: { more: data.pagination && data.pagination.more }
      })
    }
  }

  loadInitialOptions(url, selectEl) {
    if (!url || selectEl.options.length > 0) return Promise.resolve()

    return new Promise(resolve => {
      Rails.ajax({
        url: `${url}?page=1`,
        type: "GET",
        dataType: "json",
        success: data => {
          if (data && data.results) {
            data.results.forEach(result => selectEl.add(new Option(result.text, result.id, false, false)))
          }
          resolve()
        },
        error: () => resolve()
      })
    })
  }
}
